export class HttpError extends Error {
  status: number;

  constructor(status: number, message?: string) {
    super(message || `HTTP Error ${status}`);
    this.name = 'HttpError';
    this.status = status;
    Object.setPrototypeOf(this, HttpError.prototype);
  }
}

export function createHttpError(status: number, message?: string): HttpError {
  return new HttpError(status, message);
}

export function isHttpError(error: unknown): error is HttpError {
  return (
    error instanceof HttpError || (error as HttpError)?.status !== undefined
  );
}
